import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import 'bootstrap/dist/css/bootstrap.min.css';

const StandardDropdown = ({ id, text, options, white=false, onClick=null, default_selected="-1", onSelect=null }) => {
  const [selectedItem, setSelectedItem] = useState(text);
  const [selectedID, setSelectedID] = useState(default_selected);

  const handleSelect = (eventKey, event) => {
    setSelectedID(event.target.id)
    setSelectedItem(event.target.textContent);
    if (onSelect) {
      onSelect(event.target.id)
    }
  };

  const toggle_class = white ? "standard-dropdown-toggle white" : "standard-dropdown-toggle"

  return (
    <Dropdown className='width-100' onSelect={handleSelect}>
      <Dropdown.Toggle className={toggle_class} id={id} data-selected={selectedID}>
        {selectedItem}
      </Dropdown.Toggle>

      <Dropdown.Menu className='width-100'>
        {options.map((option, idx) => (
          <Dropdown.Item id={option.id} eventKey={idx + 1} onClick={onClick}>{option.val}</Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default StandardDropdown;

